var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpace2TopFloor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 660.25 165.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcf76d;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38 {\n        mix-blend-mode: multiply;\n        opacity: .5;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-39 {\n        isolation: isolate;\n      }\n\n      .cls-40 {\n        fill: #fc8b4f;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-41 {\n        fill: #fccc4f;\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-43 {\n        fill: #fcae4f;\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2346.89,
    y1: 191.31,
    x2: 2346.89,
    y2: -14.05,
    gradientTransform: "translate(2677.02 -29.62) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#390180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#380481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#371084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#34248a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#314093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2c639e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#278fab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#21c2bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1edcc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119596"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3661.82,
    y1: 3109.51,
    x2: 3693.11,
    y2: 3410.11,
    gradientTransform: "translate(-2708.58 -3590.97) rotate(90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6000a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8b25f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00abff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3622.3,
    y1: 3186.11,
    x2: 3649.9,
    y2: 3451.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3626.8,
    y1: 3221.52,
    x2: 3637.15,
    y2: 3320.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3718.47,
    y1: 3185.15,
    x2: 3731.24,
    y2: 3307.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3686.45,
    y1: 3203.84,
    x2: 3690.76,
    y2: 3245.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 3729.33,
    y1: 3260.48,
    x2: 3733.32,
    y2: 3298.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 3621.77,
    y1: 3147.68,
    x2: 3637.89,
    y2: 3302.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 3605.67,
    y1: 3255.85,
    x2: 3614.99,
    y2: 3345.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 3703.52,
    y1: 3213.52,
    x2: 3724.44,
    y2: 3414.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 542.02,
    y1: -2997.2,
    x2: 573.31,
    y2: -2696.61,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 502.49,
    y1: -2920.6,
    x2: 530.1,
    y2: -2655.39,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 507,
    y1: -2885.19,
    x2: 517.34,
    y2: -2785.78,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 598.67,
    y1: -2921.57,
    x2: 611.44,
    y2: -2798.87,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 566.65,
    y1: -2902.87,
    x2: 570.96,
    y2: -2861.51,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 609.53,
    y1: -2846.24,
    x2: 613.52,
    y2: -2807.9,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 501.96,
    y1: -2959.03,
    x2: 518.09,
    y2: -2804.09,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 485.87,
    y1: -2850.86,
    x2: 495.19,
    y2: -2761.31,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 583.72,
    y1: -2893.19,
    x2: 604.64,
    y2: -2692.21,
    gradientTransform: "translate(-141.75 -2742.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2254.76,
    y1: 114.63,
    x2: 2315.57,
    y2: 114.63,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2198.38,
    y1: 74.34,
    x2: 2255.12,
    y2: 74.34,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2265.96,
    y1: 69.52,
    x2: 2287.05,
    y2: 69.52,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2288.78,
    y1: 162.2,
    x2: 2314.14,
    y2: 162.2,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2320.3,
    y1: 126.2,
    x2: 2328.61,
    y2: 126.2,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2265.46,
    y1: 169.05,
    x2: 2273.38,
    y2: 169.05,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2305.32,
    y1: 68.02,
    x2: 2338.38,
    y2: 68.02,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2238.26,
    y1: 48.01,
    x2: 2256.93,
    y2: 48.01,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 2212.67,
    y1: 152.85,
    x2: 2254.15,
    y2: 152.85,
    gradientTransform: "translate(-2016.77 196.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2392.85,
    y1: 6206.9,
    x2: -2361.56,
    y2: 6507.5,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -2432.38,
    y1: 6283.51,
    x2: -2404.78,
    y2: 6548.71,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -2427.87,
    y1: 6318.91,
    x2: -2417.53,
    y2: 6418.32,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -2336.2,
    y1: 6282.54,
    x2: -2323.43,
    y2: 6405.23,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -2368.22,
    y1: 6301.23,
    x2: -2363.91,
    y2: 6342.6,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -2325.34,
    y1: 6357.87,
    x2: -2321.35,
    y2: 6396.21,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -2432.91,
    y1: 6245.08,
    x2: -2416.78,
    y2: 6400.02,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -2449,
    y1: 6353.24,
    x2: -2439.68,
    y2: 6442.79,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -2351.15,
    y1: 6310.91,
    x2: -2330.23,
    y2: 6511.9,
    gradientTransform: "translate(-2291.76 -6297.21) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M20.13.71h620.03c11.09,0,20.09,9,20.09,20.09v144.97H0V20.84C0,9.73,9.02.71,20.13.71Z",
    transform: "translate(660.25 166.48) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M585.1,88.28c1.31,1.17,1.62,3.32.75,4.9-3.04,5.54-5.95,11.16-8.73,16.85-.54,1.1-1.49,1.76-2.51,1.75-7.98-.07-15.96.42-23.91,1.46-.98.13-1.93-.36-2.54-1.32-6.72-10.53-14.01-20.68-21.85-30.34-1.09-1.34-1.04-3.49.14-4.96,4.62-5.74,9.44-11.31,14.46-16.69,1.07-1.15,2.66-1.44,3.91-.72,14.44,8.22,27.91,18.02,40.28,29.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M586.86,55.5c-1.36-1.65-1.13-4.16.54-5.38,8.67-7.2,35.98-24.26,44.36-27.61,1.26-.62,2.87-.34,4.08.71,1.81,1.56,3.61,3.14,5.39,4.75,1.03.93,1.58,2.26,1.47,3.52-1.02,11.33-2.1,22.65-3.25,33.95-.18,1.77-1.51,2.96-3.14,2.85-12.43-.84-24.71-.48-36.77,1.02-1.13.14-2.27-.39-3.02-1.39-3.12-4.22-6.35-8.36-9.67-12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M554.63,41.67c-.62-.96-.75-2.18-.34-3.3.88-2.4,1.78-4.79,2.7-7.17.6-1.57,2.18-2.56,3.81-2.37,3.81.44,7.61.98,11.39,1.62,2.1.36,3.4,2.5,2.82,4.57-1,3.59-1.97,7.19-2.92,10.8-.19.73-.6,1.39-1.16,1.87-1.72,1.48-3.42,2.98-5.1,4.5-1.58,1.43-3.95,1.09-5.06-.74-1.99-3.29-4.04-6.55-6.12-9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M551.11,131.95c.95.83,1.4,2.37,1.14,3.85-.44,2.49-.87,4.98-1.29,7.47-.22,1.33-.96,2.38-1.9,2.74-3.05,1.15-6.07,2.39-9.06,3.72-.71.32-1.48.2-2.13-.32-3.09-2.48-6.26-4.88-9.5-7.17-.95-.67-1.51-2.05-1.4-3.51.44-6.02.94-12.05,1.52-18.08.24-2.59,2.51-4.14,4.28-2.92,6.38,4.39,12.5,9.14,18.34,14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M519.81,93.41c.72.37.93,2.58.99,4.37.04,1.41-.62,2.78-1.67,3.52-.6.42-1.19.85-1.78,1.28-1.9,1.37-4.21.15-4.47-2.39-.12-1.23-.24-2.47-.36-3.7-.27-2.67,2-5,4.17-4.26,1.38.47,2.65.94,3.13,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M568.84,137.4c1.04-.99,2.02-1.89,2.43-2.19.62-.46,2.08.59,3.18,1.57.87.77,1.31,2.17,1.16,3.56-.09.79-.17,1.58-.26,2.37-.28,2.54-2.29,3.9-3.9,2.65-.78-.61-1.56-1.21-2.35-1.8-1.71-1.28-1.88-4.6-.26-6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M534.98,21.27c.26,3,.53,6.01.79,9.01.07.8-.13,1.63-.56,2.35-4.25,7.12-8.27,14.37-12.06,21.73-.39.76-.99,1.38-1.71,1.76-2.41,1.29-4.81,2.63-7.19,4.01-1.74,1.01-3.74.39-4.47-1.4-2.21-5.44-4.47-10.85-6.79-16.23-.29-.68-.35-1.47-.17-2.27,1.21-5.29,2.49-10.57,3.84-15.83.41-1.62,1.81-2.95,3.43-3.25,7.09-1.3,14.19-2.25,21.28-2.85,1.89-.16,3.45,1.14,3.6,2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M602.23,19.45c-1.13,1.63-2.24,3.27-3.34,4.92-.34.51-.81.91-1.36,1.17-1.61.77-3.21,1.55-4.8,2.35-1.67.84-3.75.22-4.79-1.43-1.05-1.68-2.11-3.35-3.18-5.02-.99-1.53-.73-3.52.63-4.68,2.16-1.84,4.35-3.65,6.56-5.42,1.21-.97,2.96-1.03,4.34-.16,1.6,1.01,3.19,2.04,4.77,3.09,1.79,1.19,2.3,3.53,1.17,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M605.76,149.57c-.23-.12-.46-.28-.66-.48-5.35-5.33-10.96-10.38-16.81-15.11-1.34-1.08-1.76-3.45-.87-5.18,6.16-12.01,12.95-23.67,20.35-34.89.55-.83,1.39-1.31,2.31-1.3,4.12.05,8.26.24,12.42.57,1.55.12,2.87,1.61,3.06,3.44,1.2,11.27,2.15,22.54,2.87,33.78.04.65-.05,1.29-.27,1.87-2.7,7.14-5.31,14.33-7.81,21.57-.61,1.75-2.08,2.52-3.36,1.77-3.69-2.15-7.43-4.17-11.22-6.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M417.7,70.86c1.17-1.31,3.32-1.62,4.9-.75,5.54,3.04,11.16,5.95,16.85,8.73,1.1.54,1.76,1.49,1.75,2.51-.07,7.98.42,15.96,1.46,23.91.13.98-.36,1.93-1.32,2.54-10.53,6.72-20.68,14.01-30.34,21.85-1.34,1.09-3.49,1.04-4.96-.14-5.74-4.62-11.31-9.44-16.69-14.46-1.15-1.07-1.44-2.66-.72-3.91,8.22-14.44,18.02-27.91,29.07-40.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M384.92,69.1c-1.65,1.36-4.16,1.13-5.38-.54-7.2-8.67-24.26-35.98-27.61-44.36-.62-1.26-.34-2.87.71-4.08,1.56-1.81,3.14-3.61,4.75-5.39.93-1.03,2.26-1.58,3.52-1.47,11.33,1.02,22.65,2.1,33.95,3.25,1.77.18,2.96,1.51,2.85,3.14-.84,12.43-.48,24.71,1.02,36.77.14,1.13-.39,2.27-1.39,3.02-4.22,3.12-8.36,6.35-12.42,9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M371.08,101.33c-.96.62-2.18.75-3.3.34-2.4-.88-4.79-1.78-7.17-2.7-1.57-.6-2.56-2.18-2.37-3.81.44-3.81.98-7.61,1.62-11.39.36-2.1,2.5-3.4,4.57-2.82,3.59,1,7.19,1.97,10.8,2.92.73.19,1.39.6,1.87,1.16,1.48,1.72,2.98,3.42,4.5,5.1,1.43,1.58,1.09,3.95-.74,5.06-3.29,1.99-6.55,4.04-9.78,6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M461.37,104.85c.83-.95,2.37-1.4,3.85-1.14,2.49.44,4.98.87,7.47,1.29,1.33.22,2.38.96,2.74,1.9,1.15,3.05,2.39,6.07,3.72,9.06.32.71.2,1.48-.32,2.13-2.48,3.09-4.88,6.26-7.17,9.5-.67.95-2.05,1.51-3.51,1.4-6.02-.44-12.05-.94-18.08-1.52-2.59-.24-4.14-2.51-2.92-4.28,4.39-6.38,9.14-12.5,14.2-18.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.83,136.15c.37-.72,2.58-.93,4.37-.99,1.41-.04,2.78.62,3.52,1.67.42.6.85,1.19,1.28,1.78,1.37,1.9.15,4.21-2.39,4.47-1.23.12-2.47.24-3.7.36-2.67.27-5-2-4.26-4.17.47-1.38.94-2.65,1.19-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M466.82,87.12c-.99-1.04-1.89-2.02-2.19-2.43-.46-.62.59-2.08,1.57-3.18.77-.87,2.17-1.31,3.56-1.16.79.09,1.58.17,2.37.26,2.54.28,3.9,2.29,2.65,3.9-.61.78-1.21,1.56-1.8,2.35-1.28,1.71-4.6,1.88-6.16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M350.68,120.98c3-.26,6.01-.53,9.01-.79.8-.07,1.63.13,2.35.56,7.12,4.25,14.37,8.27,21.73,12.06.76.39,1.38.99,1.76,1.71,1.29,2.41,2.63,4.81,4.01,7.19,1.01,1.74.39,3.74-1.4,4.47-5.44,2.21-10.85,4.47-16.23,6.79-.68.29-1.47.35-2.27.17-5.29-1.21-10.57-2.49-15.83-3.84-1.62-.41-2.95-1.81-3.25-3.43-1.3-7.09-2.25-14.19-2.85-21.28-.16-1.89,1.14-3.45,2.98-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M348.87,53.72c1.63,1.13,3.27,2.24,4.92,3.34.51.34.91.81,1.17,1.36.77,1.61,1.55,3.21,2.35,4.8.84,1.67.22,3.75-1.43,4.79-1.68,1.05-3.35,2.11-5.02,3.18-1.53.99-3.52.73-4.68-.63-1.84-2.16-3.65-4.35-5.42-6.56-.97-1.21-1.03-2.96-.16-4.34,1.01-1.6,2.04-3.19,3.09-4.77,1.19-1.79,3.53-2.3,5.17-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M478.99,50.2c-.12.23-.28.46-.48.66-5.33,5.35-10.38,10.96-15.11,16.81-1.08,1.34-3.45,1.76-5.18.87-12.01-6.16-23.67-12.95-34.89-20.35-.83-.55-1.31-1.39-1.3-2.31.05-4.12.24-8.26.57-12.42.12-1.55,1.61-2.87,3.44-3.06,11.27-1.2,22.54-2.15,33.78-2.87.65-.04,1.29.05,1.87.27,7.14,2.7,14.33,5.31,21.57,7.81,1.75.61,2.52,2.08,1.77,3.36-2.15,3.69-4.17,7.43-6.05,11.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239.23,79.24c-1.31-1.17-1.62-3.32-.75-4.9,3.04-5.54,5.95-11.16,8.73-16.85.54-1.1,1.49-1.76,2.51-1.75,7.98.07,15.96-.42,23.91-1.46.98-.13,1.93.36,2.54,1.32,6.72,10.53,14.01,20.68,21.85,30.34,1.09,1.34,1.04,3.49-.14,4.96-4.62,5.74-9.44,11.31-14.46,16.69-1.07,1.15-2.66,1.44-3.91.72-14.44-8.22-27.91-18.02-40.28-29.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M237.47,112.02c1.36,1.65,1.13,4.16-.54,5.38-8.67,7.2-35.98,24.26-44.36,27.61-1.26.62-2.87.34-4.08-.71-1.81-1.56-3.61-3.14-5.39-4.75-1.03-.93-1.58-2.26-1.47-3.52,1.02-11.33,2.1-22.65,3.25-33.95.18-1.77,1.51-2.96,3.14-2.85,12.43.84,24.71.48,36.77-1.02,1.13-.14,2.27.39,3.02,1.39,3.12,4.22,6.35,8.36,9.67,12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M269.71,125.85c.62.96.75,2.18.34,3.3-.88,2.4-1.78,4.79-2.7,7.17-.6,1.57-2.18,2.56-3.81,2.37-3.81-.44-7.61-.98-11.39-1.62-2.1-.36-3.4-2.5-2.82-4.57,1-3.59,1.97-7.19,2.92-10.8.19-.73.6-1.39,1.16-1.87,1.72-1.48,3.42-2.98,5.1-4.5,1.58-1.43,3.95-1.09,5.06.74,1.99,3.29,4.04,6.55,6.12,9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M273.22,35.57c-.95-.83-1.4-2.37-1.14-3.85.44-2.49.87-4.98,1.29-7.47.22-1.33.96-2.38,1.9-2.74,3.05-1.15,6.07-2.39,9.06-3.72.71-.32,1.48-.2,2.13.32,3.09,2.48,6.26,4.88,9.5,7.17.95.67,1.51,2.05,1.4,3.51-.44,6.02-.94,12.05-1.52,18.08-.24,2.59-2.51,4.14-4.28,2.92-6.38-4.39-12.5-9.14-18.34-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M304.52,74.11c-.72-.37-.93-2.58-.99-4.37-.04-1.41.62-2.78,1.67-3.52.6-.42,1.19-.85,1.78-1.28,1.9-1.37,4.21-.15,4.47,2.39.12,1.23.24,2.47.36,3.7.27,2.67-2,5-4.17,4.26-1.38-.47-2.65-.94-3.13-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M255.49,30.12c-1.04.99-2.02,1.89-2.43,2.19-.62.46-2.08-.59-3.18-1.57-.87-.77-1.31-2.17-1.16-3.56.09-.79.17-1.58.26-2.37.28-2.54,2.29-3.9,3.9-2.65.78.61,1.56,1.21,2.35,1.8,1.71,1.28,1.88,4.6.26,6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M289.36,146.25c-.26-3-.53-6.01-.79-9.01-.07-.8.13-1.63.56-2.35,4.25-7.12,8.27-14.37,12.06-21.73.39-.76.99-1.38,1.71-1.76,2.41-1.29,4.81-2.63,7.19-4.01,1.74-1.01,3.74-.39,4.47,1.4,2.21,5.44,4.47,10.85,6.79,16.23.29.68.35,1.47.17,2.27-1.21,5.29-2.49,10.57-3.84,15.83-.41,1.62-1.81,2.95-3.43,3.25-7.09,1.3-14.19,2.25-21.28,2.85-1.89.16-3.45-1.14-3.6-2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M222.1,148.07c1.13-1.63,2.24-3.27,3.34-4.92.34-.51.81-.91,1.36-1.17,1.61-.77,3.21-1.55,4.8-2.35,1.67-.84,3.75-.22,4.79,1.43,1.05,1.68,2.11,3.35,3.18,5.02.99,1.53.73,3.52-.63,4.68-2.16,1.84-4.35,3.65-6.56,5.42-1.21.97-2.96,1.03-4.34.16-1.6-1.01-3.19-2.04-4.77-3.09-1.79-1.19-2.3-3.53-1.17-5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M218.58,17.95c.23.12.46.28.66.48,5.35,5.33,10.96,10.38,16.81,15.11,1.34,1.08,1.76,3.45.87,5.18-6.16,12.01-12.95,23.67-20.35,34.89-.55.83-1.39,1.31-2.31,1.3-4.12-.05-8.26-.24-12.42-.57-1.55-.12-2.87-1.61-3.06-3.44-1.2-11.27-2.15-22.54-2.87-33.78-.04-.65.05-1.29.27-1.87,2.7-7.14,5.31-14.33,7.81-21.57.61-1.75,2.08-2.52,3.36-1.77,3.69,2.15,7.43,4.17,11.22,6.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M83.66,93.86c-1.17,1.31-3.32,1.62-4.9.75-5.54-3.04-11.16-5.95-16.85-8.73-1.1-.54-1.76-1.49-1.75-2.51.07-7.98-.42-15.96-1.46-23.91-.13-.98.36-1.93,1.32-2.54,10.53-6.72,20.68-14.01,30.34-21.85,1.34-1.09,3.49-1.04,4.96.14,5.74,4.62,11.31,9.44,16.69,14.46,1.15,1.07,1.44,2.66.72,3.91-8.22,14.44-18.02,27.91-29.07,40.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M116.44,95.62c1.65-1.36,4.16-1.13,5.38.54,7.2,8.67,24.26,35.98,27.61,44.36.62,1.26.34,2.87-.71,4.08-1.56,1.81-3.14,3.61-4.75,5.39-.93,1.03-2.26,1.58-3.52,1.47-11.33-1.02-22.65-2.1-33.95-3.25-1.77-.18-2.96-1.51-2.85-3.14.84-12.43.48-24.71-1.02-36.77-.14-1.13.39-2.27,1.39-3.02,4.22-3.12,8.36-6.35,12.42-9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M130.28,63.38c.96-.62,2.18-.75,3.3-.34,2.4.88,4.79,1.78,7.17,2.7,1.57.6,2.56,2.18,2.37,3.81-.44,3.81-.98,7.61-1.62,11.39-.36,2.1-2.5,3.4-4.57,2.82-3.59-1-7.19-1.97-10.8-2.92-.73-.19-1.39-.6-1.87-1.16-1.48-1.72-2.98-3.42-4.5-5.1-1.43-1.58-1.09-3.95.74-5.06,3.29-1.99,6.55-4.04,9.78-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M40,59.86c-.83.95-2.37,1.4-3.85,1.14-2.49-.44-4.98-.87-7.47-1.29-1.33-.22-2.38-.96-2.74-1.9-1.15-3.05-2.39-6.07-3.72-9.06-.32-.71-.2-1.48.32-2.13,2.48-3.09,4.88-6.26,7.17-9.5.67-.95,2.05-1.51,3.51-1.4,6.02.44,12.05.94,18.08,1.52,2.59.24,4.14,2.51,2.92,4.28-4.39,6.38-9.14,12.5-14.2,18.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.53,28.56c-.37.72-2.58.93-4.37.99-1.41.04-2.78-.62-3.52-1.67-.42-.6-.85-1.19-1.28-1.78-1.37-1.9-.15-4.21,2.39-4.47,1.23-.12,2.47-.24,3.7-.36,2.67-.27,5,2,4.26,4.17-.47,1.38-.94,2.65-1.19,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M34.54,77.6c.99,1.04,1.89,2.02,2.19,2.43.46.62-.59,2.08-1.57,3.18-.77.87-2.17,1.31-3.56,1.16-.79-.09-1.58-.17-2.37-.26-2.54-.28-3.9-2.29-2.65-3.9.61-.78,1.21-1.56,1.8-2.35,1.28-1.71,4.6-1.88,6.16-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M150.68,43.73c-3,.26-6.01.53-9.01.79-.8.07-1.63-.13-2.35-.56-7.12-4.25-14.37-8.27-21.73-12.06-.76-.39-1.38-.99-1.76-1.71-1.29-2.41-2.63-4.81-4.01-7.19-1.01-1.74-.39-3.74,1.4-4.47,5.44-2.21,10.85-4.47,16.23-6.79.68-.29,1.47-.35,2.27-.17,5.29,1.21,10.57,2.49,15.83,3.84,1.62.41,2.95,1.81,3.25,3.43,1.3,7.09,2.25,14.19,2.85,21.28.16,1.89-1.14,3.45-2.98,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M152.49,110.99c-1.63-1.13-3.27-2.24-4.92-3.34-.51-.34-.91-.81-1.17-1.36-.77-1.61-1.55-3.21-2.35-4.8-.84-1.67-.22-3.75,1.43-4.79,1.68-1.05,3.35-2.11,5.02-3.18,1.53-.99,3.52-.73,4.68.63,1.84,2.16,3.65,4.35,5.42,6.56.97,1.21,1.03,2.96.16,4.34-1.01,1.6-2.04,3.19-3.09,4.77-1.19,1.79-3.53,2.3-5.17,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M22.37,114.51c.12-.23.28-.46.48-.66,5.33-5.35,10.38-10.96,15.11-16.81,1.08-1.34,3.45-1.76,5.18-.87,12.01,6.16,23.67,12.95,34.89,20.35.83.55,1.31,1.39,1.3,2.31-.05,4.12-.24,8.26-.57,12.42-.12,1.55-1.61,2.87-3.44,3.06-11.27,1.2-22.54,2.15-33.78,2.87-.65.04-1.29-.05-1.87-.27-7.14-2.7-14.33-5.31-21.57-7.81-1.75-.61-2.52-2.08-1.77-3.36,2.15-3.69,4.17-7.43,6.05-11.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.01,30.84c9.35-.35,23.29-13.27,32.1-13.27,14.25,0,51.12,13.87,56.56,13.87,4.37,0,25.98-16.28,31.84-16.28s28.91,2.41,44.83,4.22c15.92,1.81,47.35,19.3,50.28,19.3s35.61-16.88,43.57-15.08c7.96,1.81,35.19,14.47,38.97,14.47,1.99,0,9.38-3.54,16.08-6.88V1.81h-314.24v29.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M346.01,29.03c9.35-.35,23.29-13.27,32.1-13.27,14.25,0,51.12,13.87,56.56,13.87,4.37,0,25.98-16.28,31.84-16.28s28.91,2.41,44.83,4.22,47.35,19.3,50.28,19.3,35.61-16.88,43.57-15.08,35.19,14.47,38.97,14.47c1.99,0,9.38-3.54,16.08-6.88V0h-314.24v29.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M600.12,22.13c2.13-.45,3.89-.6,5.08-.33,7.96,1.81,35.19,14.47,38.97,14.47,0,0-15.08-21.45-27.81-36.27h-19.31c.5,9.34,2.7,20.3,3.07,22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M618.44,26.53l-19.1-26.53h-1.84c-.06.86-.14,1.92-.23,3.13.74,8.51,2.51,17.38,2.85,19.01,2.13-.45,3.89-.6,5.08-.33,2.72.62,7.71,2.51,13.23,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M464.85,12.75l-.07.92c.67-.2,1.26-.31,1.75-.31,5.87,0,28.91,2.41,44.83,4.22s47.35,19.3,50.28,19.3c0,0-17.75-22.04-32.91-36.87h-45.95c-9.72,6.41-17.93,12.75-17.93,12.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M511.35,17.58c2,.23,4.25.7,6.65,1.36l-15.53-18.94h-19l-2.49,1.19c-8.91,5.98-16.13,11.56-16.13,11.56l-.07.92c.67-.2,1.26-.31,1.75-.31,5.87,0,28.91,2.41,44.83,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M561.63,36.87s-1.23-1.53-3.31-4.04l-5.9.19c4.85,2.27,8.33,3.86,9.21,3.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M346.01,29.03c9.35-.35,23.29-13.27,32.1-13.27,14.25,0,51.12,13.87,56.56,13.87,0,0-16.28-18.93-29.55-29.64h-26.47c-14.14,10.56-32.65,29.03-32.65,29.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M395.17,18.66c-3.42-6.45-7.59-13.81-10.9-18.66h-5.61c-14.14,10.56-32.65,29.03-32.65,29.03,9.35-.35,23.29-13.27,32.1-13.27,4.19,0,10.33,1.2,17.05,2.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M564.15,26.02c1.68,1.81,27.65-11.46,27.65-11.46l-1.73-14.56h-36.35c2.43,8.57,9.09,24.58,10.43,26.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.85,26.62c1.31.94,9.21-2.98,14.4-5.63V0h-23.37c3.23,10.77,7.9,25.85,8.97,26.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.95,16.37c3.46-1.24,8.37-8.91,12.6-16.37h-14.54v16.51c.66.12,1.31.09,1.94-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.77,0c4.77,6.94,10.93,14.22,14.42,16.37,4.03,2.48,19.5-8.95,28.81-16.37h-43.23Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace2TopFloor);
export default __webpack_public_path__ + "static/media/SPACE2_TOP_FLOOR.c5276e45b61abe53128503f8a8bde046.svg";
export { ForwardRef as ReactComponent };